import { Injectable} from '@angular/core';
import { EsignatureService } from '../../esignature/services/esignature.service';
import { EpayPaymentFormComponent } from '../../payment/components/epay-payment-form/epay-payment-form.component';
import { PolicyProcessData } from '../../product-workflow/model/policy/PolicyProcessData';
import { IProductWorkflowService } from '../../product-workflow/model/product-workflow-service';
import { ScreenManagersModule } from '../screen-managers.module';
import { MissingSignatureError } from './model/missing-signature-error';
import { IPropertyPaymentScreen } from './property-payment-screen';
import { SomethingWentWrongService } from '../../modals/services/something-went-wrong.service';



@Injectable({
  providedIn: ScreenManagersModule
})
export class PaymentScreenEpayManagerService {

  screen: IPropertyPaymentScreen;
  productWorkflow: IProductWorkflowService;

  constructor(
    private esignatureService: EsignatureService,
    public somethingWentWrongService: SomethingWentWrongService,
  ) { }

  public async submitClick(paymentComponent: EpayPaymentFormComponent, lang: string, successUrl: string, failureUrl: string, epayRedirectUrl: string) {
      const pid = this.screen.getEsignatureHolderPID();

      if (! pid) {
        throw new Error('User ID not found');
      }

      const hasValidsignature = await this.esignatureService.hasValidsignature(pid);

      if (hasValidsignature) {
        this.submitEpay(paymentComponent, lang, successUrl, failureUrl, epayRedirectUrl);
      } else {
        throw new MissingSignatureError();
      }
  }

  private async submitEpay(paymentComponent: EpayPaymentFormComponent, lang: string, successUrl: string, failureUrl: string, epayRedirectUrl: string) {
      const registerData = await this.screen.registerPolicyPayment();

      if (!registerData || !registerData.success || ! registerData.data || ! registerData.data.token) {
        //TODO: Add message to the user
        this.somethingWentWrongService.showInternalServerDialog();
        throw new Error('Invoice data not recieved correctly!');
      }

      const epayToken = registerData.data.token;

      const processId = registerData.data.policy_creation_process_id;

      const policyProcessData: PolicyProcessData = {
        policy_creation_process_id: processId
      }

      this.productWorkflow.setPolicyProcessData(policyProcessData);
      this.productWorkflow.setVposData(undefined);
      this.productWorkflow.setEpayData(epayToken);
      this.productWorkflow.setInvoiceData({invoice: epayToken.invoice.toString(), amount: parseFloat(epayToken.amount), currency: epayToken.currency});

      await paymentComponent.submit({
        paymentUrl: epayRedirectUrl,
        lang,
        encode: epayToken.encoded,
        checksum: epayToken.checksum,
        epaySuccessUrl: successUrl,
        epayFailureUrl: failureUrl,
      });
  }

}
